import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SyncProgressBarComponent } from '@gelato-api-ui/sdk/src/lib/shared/sync-progress-bar/sync-progress-bar.component';

@Component({
  standalone: true,
  selector: 'gd-sync-progress-dimmer',
  templateUrl: './sync-progress-dimmer.component.html',
  styleUrls: ['./sync-progress-dimmer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SyncProgressBarComponent],
})
export class SyncProgressDimmerComponent {
  @Input() percent: number;
  @Input() label: string;
}
